import { transportationCallForHelpComponent } from './transportation-call-for-help.component';
import { CallForHelpService } from './transportation-call-for-help.service';

export const transportationCallForHelp = angular
     .module('components.transportationCallForHelp', [])
     .component('transportationCallForHelp', transportationCallForHelpComponent)
     .service('CallForHelpService', CallForHelpService)
     .name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-call-for-help/transportation-call-for-help.module.js